export default "__VITE_ASSET__9c7ec972__"